import db from '@/js/services/contracts/Database';
import Dexie from 'dexie';

export default {
  getAll() {
    return db.crops.where('sync_status').notEqual(2).toArray();
  },
  updateById(id, updateObj) {
    return db.crops.update(id, Dexie.deepClone(updateObj));
  },
  getById(ids) {
    return db.crops.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  add(data) {
    return db.crops.add(Dexie.deepClone(data));
  },
  async deleteById(id) {
    return db.crops.where('id').equals(id).delete();
  },
  getAllSyncPending() {
    return db.crops.where('sync_status').above(0).toArray();
  },

};
